module.exports = __webpack_public_path__ + "static/img/gnmk_8@2x.3e6223ed.png";